<template>
  <v-col :style="dateInputStyle">
    <v-menu
      class="menu-border"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          class="date-input"
          :label="label"
          prepend-icon="fa-regular fa-calendar"
          readonly
          hide-details
          :value="computedDateFormatted"
          v-on="on"
          outlined
          :clearable="clearable || false"
          @input="updateValue"
          :tabindex="tabstop ? '' : tabindex || 1"
        ></v-text-field>
      </template>
      <v-date-picker
        class="date-body"
        no-title
        color="input"
        locale="pt-br"
        :v-bind="$attrs"
        :value="value"
        :max="maxDate"
        :min="minDate"
        :range="range"
        @input="updateValue"
      />
    </v-menu>
  </v-col>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
    };
  },

  props: [
    "value",
    "range",
    "label",
    "maxDate",
    "minDate",
    "clearable",
    "width",
    "tabstop",
    "tabindex",
  ],

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.value);
    },

    dateInputStyle() {
      return this.width
        ? {
            "min-width": this.width + " !important",
            "max-width": this.width + " !important",
          }
        : {
            "min-width": this.range
              ? this.clearable
                ? "320px"
                : "300px"
              : this.clearable
              ? "210px"
              : "190px",
            "max-width": this.range
              ? this.clearable
                ? "320px"
                : "300px"
              : this.clearable
              ? "210px"
              : "190px",
          };
    },
  },

  methods: {
    formatDate(date) {
      if (!date || (this.range && !date[0])) return null;

      if (this.range)
        return date
          .map((d) => {
            const [year, month, day] = d.split("-");
            return `${day}/${month}/${year}`;
          })
          .join(" ~ ");
      else {
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      }
    },

    updateValue: function (value) {
      if (this.range) {
        if (!value) {
          this.$emit("input", ["", ""]);
        } else {
          if (value.length === 2) this.menu = false;

          this.$emit("input", value);
        }
      } else {
        this.menu = false;

        if (!value) {
          this.$emit("input", "");
        } else {
          this.$emit("input", value);
        }
      }
    },
  },

  watch: {
    value: function (val) {
      this.$emit("input", val);
    },
  },
};
</script>

<style>
@import "./styles.css";
</style>
